<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="mchId">
        <el-input v-model="queryParams.mchId" placeholder="商户号"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item  prop="appId">
        <el-input v-model="queryParams.appId" placeholder="APPID"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="table" style="margin-top: 10px">
      <el-table :data="tableData" border >
        <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="appId" label="APPID" align="center" min-width="100"></el-table-column>
        <el-table-column prop="appName" label="公众号主体" width="100" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="mchId" label="商户号" width="100" align="center"></el-table-column>
        <el-table-column prop="mchName" label="商户主体" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="type" label="接收方类型" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="account" label="接收方账号" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="name" label="分账接收方" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="percent" label="分账金额（%）" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="relationType" label="关系类型" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="customRelation" label="自定义的分账关系" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="status" label="状态" align="center" width="80">
            <template slot-scope="{row}">
              <el-tag type="success" v-if="row.status =='1'">有效</el-tag>
              <el-tag type="danger" v-else>无效</el-tag>
            </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { ProfitSharingReceiversList } from "@/api/profitsharing.js";
export default {
  name: "ProfitSharingReceivers",
  data() {
    return{
      queryParams:{
        company:undefined,
        protocol:undefined,
        operationName:undefined,
        orientationNum:undefined,
        ip:undefined,
        url:undefined,
        remark:undefined
      },
      tableData:[],
    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      ProfitSharingReceiversList(this.queryParams).then(res=>{
        this.tableData = res.data.data;
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.search();
    }

  },
  created() {
    this.initData();
  }
};
</script>
<style scoped lang="less">

</style>


